import { useEffect, useState } from "react";
import { IoWarningOutline, IoCloseOutline } from "react-icons/io5";

function detectVpn() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const iranTimezones = ["Asia/Tehran"];
    if (!iranTimezones.includes(tz)) return true;

    const now = new Date();
    const iranOffset = 3.5 * 60;
    const localOffset = -now.getTimezoneOffset();
    const diff = Math.abs(localOffset - iranOffset);
    if (diff > 60) return true;

    return false;
  } catch {
    return false;
  }
}

export default function VpnWarningBanner() {
  const [show,      setShow]      = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    if (detectVpn()) setShow(true);
  }, [dismissed]);

  if (!show || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9998] sm:max-w-[500px] mx-auto">
      <div className="bg-red-600 text-white px-4 py-3 flex items-center gap-3 shadow-lg">
        <IoWarningOutline className="text-xl flex-shrink-0" />
        <p className="text-xs font-semibold leading-5 flex-1">
          فیلترشکن شما روشن به نظر می‌رسد. برای جلوگیری از خطا در پرداخت، لطفاً آن را خاموش کنید.
        </p>
        <button
          onClick={() => setDismissed(true)}
          className="flex-shrink-0 opacity-80 hover:opacity-100"
        >
          <IoCloseOutline className="text-lg" />
        </button>
      </div>
    </div>
  );
}
